var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image__wrapper"},[_c('b-loading',{staticClass:"image__spinner primary-loading",attrs:{"is-full-page":false,"active":true,"can-cancel":false}}),_c('img',{staticClass:"image__item",attrs:{"data-url":_vm.src,"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }